import { useContext } from "react";
import { AuthContext } from "../Header/auth - context";

export const useSessionHelper = () => {
  const auth = useContext(AuthContext);

  const sessionHelper = async (user, modul, id) => {

    // const handleErrors = async (response) => {
    //   if (response.ok) return response.json();
    //   throw await response.json();
    // };

    let res;

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

   const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    }
  };

     await fetch(process.env.REACT_APP_BACKEND_URL + `/session/sessionControl?user_id=${user}&modul=${modul}&id=${id}`, requestOptions)
      .then(handleErrors)
      .then(async (data) => {
       res = data;
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          console.log(errorMessage);
        });
      });

    // const res = await fetch(
    //   `${process.env.REACT_APP_BACKEND_URL}/session/sessionControl?user_id=${user}&modul=${modul}&id=${id}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: "Bearer " + auth.token,
    //     },
    //   }
    // );
    return res;
  };

  return { sessionHelper };
};
